export default __webpack_public_path__ + "static/media/PharmacyDashboard.c6b9f69e.svg";